import React from "react";
import { Box, Button, Grid2, Typography } from "@mui/material";
import { integrationConfig } from "./integration.ts";

const IntegrationsPage = () => {
  return (
    <Box p={4}>
      <Grid2 container spacing={4}>
        {integrationConfig.map((integration) => (
          <Grid2 size={4}>
            <Box
              sx={{
                border: "1px solid #00000033",
                borderRadius: "3px",
                padding: "2rem",
              }}
            >
              <integration.icon sx={{ height: "50px" }} />
              <Typography sx={{ fontWeight: "bold" }}>
                {integration.name}
              </Typography>
              <Box sx={{ height: "6rem" }}>
                <Typography>{integration.description}</Typography>
              </Box>
              <a href={integration.url}>
                <Button variant="contained">View</Button>
              </a>
            </Box>
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
};

export default IntegrationsPage;
